<div class="ds-content-switcher" *ngIf="tabs" ngClass="{{type}} {{size}}">
  <ng-container *ngFor="let tab of tabs">
    <span [ngClass]="{'hide': tab.id === activeTab}" class="line"></span>
    <div (click)="changeTab(tab.id)" class="element ds-caption-2" [ngClass]="{'active': tab.id === activeTab }">
      {{ tab.value | translate }}
      <span *ngIf="tab.id === highlightTab" class="dot"></span>
    </div>
  </ng-container>
</div>
